import { IEvent } from '../models/edu.event';

/** ACTIONS */
export const REQUEST_EVENT = 'REQUEST_EVENT';
export const REQUEST_EVENT_SUCCESS = 'REQUEST_EVENT_SUCCESS';
export const REQUEST_EVENT_ERROR = 'REQUEST_EVENT_ERROR';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_ERROR = 'UPDATE_EVENT_ERROR';
export const ADD_EVENT = 'ADD_EVENT';
export const ADD_EVENT_SUCCESS = 'ADD_EVENT_SUCCESS';
export const ADD_EVENT_ERROR = 'ADD_EVENT_ERROR';
export const REMOVE_EVENT = 'REMOVE_EVENT';
export const REMOVE_EVENT_SUCCESS = 'REMOVE_EVENT_SUCCESS';
export const REMOVE_EVENT_ERROR = 'REMOVE_EVENT_ERROR';
export const REQUEST_EVENTS = 'REQUEST_EVENTS';
export const REQUEST_EVENTS_SUCCESS = 'REQUEST_EVENTS_SUCCESS';
export const REQUEST_EVENTS_ERROR = 'REQUEST_EVENTS_ERROR';

/** HANDLERS */
export const eventUpdateSuccess = (event:IEvent) => ({type: UPDATE_EVENT_SUCCESS, payload: event});
export const eventUpdateError = () => ({type: UPDATE_EVENT_ERROR});
export const eventAddSuccess = (event:IEvent) => ({type: ADD_EVENT_SUCCESS, payload: event});
export const eventAddError = () => ({type: ADD_EVENT_ERROR});
export const eventRemoveSuccess = (id:string) => ({type: REMOVE_EVENT_SUCCESS, payload: id});
export const eventRemoveError = () => ({type: REMOVE_EVENT_ERROR});
export const getEventSuccess = (event:IEvent) => ({type: REQUEST_EVENT_SUCCESS, payload: event});
export const getEventError = () => ({type: REQUEST_EVENT_ERROR});
export const getEventsSuccess = (events:any) => ({type: REQUEST_EVENTS_SUCCESS, payload: events});
export const getEventsError = () => ({type: REQUEST_EVENTS_ERROR});